import { config } from "../../Config";

const updateExtension = async (extensionData) => {
    const url = config.updateExtension;
    try {
        const formData = new FormData();
        formData.append("userId", extensionData.userId);
        formData.append("extensionId", extensionData.id);

        if (extensionData.extensionName !== undefined) {
            formData.append("extensionName", extensionData.extensionName);
        }
        if (extensionData.extensionDescription !== undefined) {
            formData.append("extensionDescription", extensionData.extensionDescription);
        }
        if (extensionData.extensionInstructions !== undefined) {
            formData.append("extensionInstructions", extensionData.extensionInstructions);
        }
        if (extensionData.iconClass !== undefined) {
            formData.append("iconClass", extensionData.iconClass);
        }
        if (extensionData.category !== undefined) {
            formData.append("category", extensionData.category);
        }

        if (Array.isArray(extensionData.tools)) {
            extensionData.tools.forEach((tool, index) => {
                formData.append(`tools[${index}]`, tool);
            });
        }

        if (Array.isArray(extensionData.selectedModel)) {
            extensionData.selectedModel.forEach((model, index) => {
                formData.append(`models[${index}]`, model);
            });
        }

        if (Array.isArray(extensionData.collaborators)) {
            extensionData.collaborators.forEach((collab, index) => {
                // Send as JSON string so backend gets full object {id, displayName, email}
                const collabStr = typeof collab === "string" ? collab : JSON.stringify(collab);
                formData.append(`collaborators[${index}]`, collabStr);
            });
        }

        if (extensionData.image) {
            formData.append("image", extensionData.image);
            // console.log("Extension Image selected for update is: ", extensionData.image);
        }

        const response = await fetch(url, {
            method: "POST",
            body: formData,
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.error || `Failed to update extension. Status: ${response.status}`);
        }

        const updatedExtension = await response.json();
        return { success: true, extension: updatedExtension };
    } catch (error) {
        // console.error("Error updating extension:", error);
        return { success: false, error: error.message };
    }
};

export default updateExtension;
